import React from 'react';
import styles from './About.module.css';

const About: React.FC = () => {
  return (
    <div className={styles.about}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.imageWrapper}>
            <div className={styles.imageContainer}>
              {/* Placeholder for author photo - user should replace with actual image */}
              <img
                src="/author-photo.jpg"
                alt="Sindhu Dokras"
                className={styles.authorImage}
                onError={(e) => {
                  // Fallback if image doesn't exist yet
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  if (target.nextElementSibling) {
                    (target.nextElementSibling as HTMLElement).style.display = 'flex';
                  }
                }}
              />
              <div className={styles.imagePlaceholder}>
                <span>SD</span>
              </div>
            </div>
          </div>

          <div className={styles.bio}>
            <h1 className={styles.title}>About Sindhu Dokras</h1>

            <div className={styles.bioText}>
              <p>
                Sindhu Dokras (1932–2018) lived a life of creativity, service, and leadership. She made enduring
                contributions to the Marathi community as an esthetician, health educator, writer, and entrepreneur.
                Having spent her formative and professional years in India, she founded Sairandhri Services,
                through which she empowered countless women with knowledge of personal health, beauty and
                self-care.
              </p>

              <p>
                Sindhu shared her expertise widely—through weekly columns in Marathi and Gujarati magazines,
                her book <em>Prasadhana</em>, and television programs on Mumbai Doordarshan. She also established the
                Nuja beauty products brand and founded the Skin Care Association of India, leaving behind a legacy
                continued by her students and mentees in Maharashtra and across the world.
              </p>

              <p>
                In her later years, Sindhu moved to the United States to be close to her children and grandchildren.
                She devoted herself to oil painting and creative writing, pursuits that reflected her lifelong love of
                learning and expression. This collection of Marathi proverbs stands as one of her final gifts—a
                thoughtful effort to preserve wisdom, language, and culture for future generations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
